<template>
  <VDialog v-model="loading" fullscreen>
    <VContainer fluid fill-height class="progressContainer">
      <v-row justify="center" align="center">
        <v-col justify="center" align="center">
          <VProgressCircular indeterminate color="primary" />
          <span v-show="progressVisible" class="progress">
            {{ progressText }}
          </span>
        </v-col>
      </v-row>
    </VContainer>
  </VDialog>
</template>

<script>
export default {
  name: "PsOverlay",
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    progressText: {
      type: String,
      require: true,
    },
    progressVisible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.progressContainer {
  background-color: rgba(255, 255, 255, 0.8);
}

.progress {
  font-style: italic;
  font-weight: bold;
  float: right;
  padding: 5px;
  margin-left: 10px;
}
</style>
